import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createVDKEventLanguageAsync, deleteVDKEventLanguageAsync, getVDKEventLanguageByIdAsync, getVDKEventLanguagesByEventIdAsync, updateVDKEventLanguageAsync } from './VDKEventLanguagesThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const VDKEventLanguagesSlice = createSlice({
    name: 'VDKEventLanguages',
    initialState,
    reducers: {
        resetVDKEventLanguagesApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createVDKEventLanguageAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createVDKEventLanguageAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.VDKEventLanguage = action.payload;
            if (state.VDKEventLanguages) {
                state.VDKEventLanguages.push(action.payload);
            }
        })
            .addCase(createVDKEventLanguageAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Update
            .addCase(updateVDKEventLanguageAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateVDKEventLanguageAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.VDKEventLanguage = action.payload;
            if (state.VDKEventLanguages && Array.isArray(state.VDKEventLanguages)) {
                const idx = state.VDKEventLanguages.findIndex((l) => l.id === action.payload.id);
                if (idx >= 0)
                    state.VDKEventLanguages[idx] = action.payload;
            }
        })
            .addCase(updateVDKEventLanguageAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Delete
            .addCase(deleteVDKEventLanguageAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteVDKEventLanguageAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteVDKEventLanguageAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Id
            .addCase(getVDKEventLanguageByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getVDKEventLanguageByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.VDKEventLanguage = action.payload;
        })
            .addCase(getVDKEventLanguageByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Event Id
            .addCase(getVDKEventLanguagesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getVDKEventLanguagesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.VDKEventLanguages = action.payload;
        })
            .addCase(getVDKEventLanguagesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetVDKEventLanguagesApiState } = VDKEventLanguagesSlice.actions;
export default VDKEventLanguagesSlice.reducer;
